import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCsAppealList = async (params: object) => {
  return await GET({
    url: Api.queryCsAppealList,
    params,
    showError: false,
    headers: {
      rpcType: 'dubbo',
      'Client-Id': 'iss_courier'
    }
  })
}
